module.exports = __webpack_public_path__ + "static/media/headline1.0fdf5b4e.png";